<template>
  <div class="category-strip">
    <div v-if="name" class="name">
      {{ name }}
    </div>
    <div class="category-grid">
      <a v-for="item in items" :key="item.id" :href="`#${item.id}`" @click.prevent="scrollToSection(item.id)">
        <span>{{ item.label }}</span>
        <span>⌄</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TigerCategoryStrip',
  props: {
    name: {
      type: String,
      default: ''
    },
    // [{ id: 區塊 id, label: 顯示文字 }]
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    scrollToSection(id) {
      const target = document.getElementById(id)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>
